import React from "react";
import { Link } from "react-router-dom";
import { Section, SerifH, Eyebrow, PrimaryButton, SecondaryButton } from "../components/ui-kit/Primitives";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="bg-brand-cream min-h-screen" data-testid="payment-cancel-page">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
      <Link to="/" className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-brand-green flex items-center justify-center text-brand-gold font-serif text-xl">K</div>
        <div className="leading-tight">
          <div className="font-serif text-lg text-brand-green">KBX Pathways</div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-brand-sage">To Wellness</div>
        </div>
      </Link>
    </div>
    <Section className="pt-6">
      <div className="max-w-2xl mx-auto text-center">
        <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
        <Eyebrow>Checkout canceled</Eyebrow>
        <SerifH as="h1" className="text-4xl sm:text-5xl">
          No worries — nothing was charged.
        </SerifH>
        <p className="mt-5 text-slate-600 leading-relaxed">
          Your payment was canceled and no charge was made. Whenever you're ready, you can pick up
          right where you left off, or schedule a call to talk through the right tier for your agency.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <PrimaryButton to="/packages" testid="cancel-back">View Packages</PrimaryButton>
          <SecondaryButton to="/contact" testid="cancel-contact">Schedule a Call</SecondaryButton>
        </div>
      </div>
    </Section>
  </div>
);

export default PaymentCancel;
